import { type GlobalSearchPayload } from '../../../data-access/types/GlobalSearchPayload'
import { type GlobalSearchResult } from '../../../value-objects/GlobalSearchResult'
import { type IGlobalSearchRepository } from '../../interfaces/IGlobalSearchRepository'
import { GlobalSearchUseCaseErrors } from '../GlobalSearchUseCaseErrors'

interface Dependency {
  globalSearchRepository: IGlobalSearchRepository
}

export class GetGlobalSearchResultsUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = async (
    payload: GlobalSearchPayload
  ): Promise<GlobalSearchResult> => {
    try {
      return await this.deps.globalSearchRepository.search(payload)
    } catch {
      throw new GlobalSearchUseCaseErrors({
        name: 'SEARCH_FAILED',
        message: 'Global search failed',
      })
    }
  }
}
